
  var path = 'scripts/segment-inputs-config/address/underground/typeahead-item.tpl.jade';
  var html = "<a><cian-af-metro-icon ng-if=\"match.model.lineColor\" station-id=\"{{ match.model.id }}\" line-color=\"{{ match.model.lineColor }}\" location-id=\"{{ match.model.locationId }}\"></cian-af-metro-icon><span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span></a>";
  window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
  module.exports = path;
  